import { Pill } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { FieldSelectMultiStore } from 'stores/local/shared/form/FieldSelectStore';

import ValueItem from './ValueItem';

type ValueProps = {
  store: FieldSelectMultiStore;
  maxDisplayedValues?: number;
};

const Value: React.FC<ValueProps> = ({ store, maxDisplayedValues }) => {
  if (maxDisplayedValues == null) {
    return store.value.map((item) => <ValueItem key={item.key} item={item} store={store} />);
  }

  const displayedCount =
    maxDisplayedValues === 0 ? 0 : Math.min(store.value.length, Math.max(1, maxDisplayedValues - 1));
  const values = store.value.slice(0, displayedCount);
  const showPlus = store.value.length > displayedCount;

  return (
    <>
      {values.map((item) => (
        <ValueItem key={item.key} item={item} store={store} />
      ))}
      {showPlus && <Pill>+{store.value.length - displayedCount}</Pill>}
    </>
  );
};

export default observer(Value);
